import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Feature } from '@core/configs/role';
import { RoleService } from '__services';
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  roleLogChainAdmin: boolean;
  tabs = [
    {
      title: 'Company Management',
      logchain_link: '/logchain-admin/companies',
      admin_link: '/admin/company',
      feature_id: [
        Feature.COMPANY_MANAGEMENT,
        Feature.LOGCHAIN_COMPANY_MANAGEMENT,
      ],
      access: false,
    },
    {
      title: 'User Management',
      logchain_link: '/logchain-admin/users',
      admin_link: '/admin/users',
      feature_id: [Feature.USER_MANAGEMENT, Feature.LOGCHAIN_USER_MANAGEMENT],
      access: false,
    },
    {
      title: 'Role Management',
      logchain_link: '/logchain-admin/roles',
      admin_link: '',
      feature_id: Feature.ROLE_MANAGEMENT,
      access: false,
    },
    {
      title: 'Trade Lane Management',
      logchain_link: '/logchain-admin/trade-lanes',
      admin_link: '/admin/trade-lanes',
      feature_id: [
        Feature.TRADE_LANE_MANAGEMENT,
        Feature.ADMIN_TRADE_LANE_MANAGEMENT,
      ],
      access: false,
    },
    {
      title: 'Flow Management',
      logchain_link: '/logchain-admin/default-flow',
      admin_link: '',
      feature_id: Feature.LOGCHAIN_FLOW_MANAGEMENT,
      access: false,
    },
    {
      title: 'Regulatory Transaction',
      logchain_link: '/logchain-admin/transactions',
      admin_link: '',
      feature_id: Feature.LOGCHAIN_REGULATORY_FILING,
      access: false,
    },
    {
      title: 'Party Management',
      logchain_link: '',
      admin_link: '/admin/parties',
      feature_id: Feature.PARTY_MANAGEMENT,
      access: false,
    },
    {
      title: 'Category Management',
      logchain_link: '',
      admin_link: '/admin/category',
      feature_id: Feature.CATEGORY_MANAGEMENT,
      access: false,
    },
    {
      title: 'Licence Management',
      logchain_link: '/logchain-admin/licence',
      admin_link: '',
      feature_id: Feature.LICENCE_MANAGEMENT,
      access: false,
    },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private roleService: RoleService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.roleLogChainAdmin =
      this.activatedRoute.snapshot.data.roleLogChainAdmin;
    const moduleId = this.activatedRoute.snapshot.data.module_id;
    for (const tab of this.tabs) {
      tab.access = this.roleService.accessFeature(tab.feature_id, moduleId);
      if (tab.feature_id === Feature.LOGCHAIN_REGULATORY_FILING) {
        tab.access = this.roleService.accessFeature(tab.feature_id);
      }
      if (this.activatedRoute.children.length === 0 && tab.access) {
        if (this.roleLogChainAdmin) {
          this.router.navigate([tab.logchain_link]);
        } else {
          this.router.navigate([tab.admin_link]);
        }
      }
    }
  }
  checkActive(tab) {
    if (
      this.router.url == '/logchain-admin/regulatory' &&
      tab.logchain_link == '/logchain-admin/companies'
    ) {
      return true;
    }
    return false;
  }
}
